import React, {createContext, useContext, useEffect, useState} from 'react';
import axios from 'axios';

const CountryListContext = createContext({list: [], loading: true, error: null});

export const CountryListProvider = ({children}) => {
    const [state, setState] = useState({list: [], loading: true, error: null});

    useEffect(() => {
        let mounted = true;
        axios.get('/ajax/countries')
            .then(resp => {
                if (!mounted) return;
                const list = Array.isArray(resp?.data?.result) ? resp.data.result : [];
                setState({list, loading: false, error: null});
            })
            .catch(err => {
                if (!mounted) return;
                console.log('CountryListProvider: failed to load /ajax/countries', err);
                setState({list: [], loading: false, error: err});
            });
        return () => { mounted = false; };
    }, []);

    return (
        <CountryListContext.Provider value={state}>
            {children}
        </CountryListContext.Provider>
    );
};

export const useCountryList = () => useContext(CountryListContext);
